import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "manifold m-claim-refund"
}

import { computed, reactive } from "@vue/runtime-core";
import { BigNumber, Contract, ethers } from "ethers";
import { watchEffect } from "vue";
import { PricingType } from "@manifoldxyz/collectible-sdk";
import { DutchAuctionContract } from "@manifoldxyz/typed-contracts/dist/contracts/ethers";
import { useStore } from "@/composables/useStore";
import { EthereumProvider } from "@/EthereumProvider";
import { TransactionManager } from "@/TransactionManager";
import ButtonComponent from "./ButtonComponent.vue";

interface ClaimRefundProps {
  showPrice: boolean;
  pricingType: PricingType;
}
type RefundData = {
  type: PricingType.DUTCH_AUCTION;
  purchaseHistory: {
    totalPaid: BigNumber;
    amount: number;
  };
  lastPurchasePrice: BigNumber;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimRefund',
  props: {
    showPrice: { type: Boolean },
    pricingType: {}
  },
  setup(__props: any) {

const props = __props;


const store = useStore();
const componentState = reactive<{ isClaiming: boolean; refundData: RefundData | null }>({
  isClaiming: false,
  refundData: null,
});

const refundAmount = computed(() => {
  if (!store.saleHasEnded) {
    return BigNumber.from(0);
  } else if (componentState.refundData?.type === PricingType.DUTCH_AUCTION) {
    const actualPrice = BigNumber.from(componentState.refundData.lastPurchasePrice).mul(
      componentState.refundData.purchaseHistory.amount
    );
    return BigNumber.from(componentState.refundData.purchaseHistory.totalPaid).sub(actualPrice);
  }

  return BigNumber.from(0);
});

const userCanClaimRefund = computed(() => {
  return store.walletAddress && store.saleHasEnded && refundAmount.value.gt(0);
});

watchEffect(async () => {
  if (store.walletAddress && props.pricingType === PricingType.DUTCH_AUCTION) {
    const provider = EthereumProvider.provider();

    if (provider) {
      const contract = store.contract! as DutchAuctionContract;
      try {
        componentState.refundData = {
          type: props.pricingType,
          purchaseHistory: await contract.purchaseHistory(store.walletAddress),
          lastPurchasePrice: await contract.lastPurchasePrice(),
        };
      } catch (e) {
        console.error(e);
      }
    }
  }
});

const buttonText = computed(() => {
  let text = "Claim Refund";

  if (componentState.isClaiming) {
    text = "Claiming...";
  } else if (!store.walletAddress) {
    text = "Connect wallet for refund claim";
  } else if (refundAmount.value.eq(0)) {
    text = "No ETH to claim";
  } else if (props.showPrice) {
    text = `${text} ${ethers.utils.formatUnits(refundAmount.value, "ether")}ETH`;
  }

  return text;
});

const claimRefund = async () => {
  const overrides = {
    from: EthereumProvider.selectedAddress(),
    value: BigNumber.from("0"),
    gasLimit: undefined,
  } as {
    from: string;
    value: BigNumber;
    gasLimit?: BigNumber;
  };
  componentState.isClaiming = true;
  const contract = store.contract!;
  const transactionManager = new TransactionManager(
    contract as unknown as Contract,
    "claimRefund",
    []
  );
  overrides.gasLimit = await transactionManager.estimateGas();

  try {
    await transactionManager.send();
  } catch (e) {
    alert(e);
  }
  componentState.isClaiming = false;
};

return (_ctx: any,_cache: any) => {
  return (_unref(store).loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(store).saleHasEnded)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              "is-loading": _unref(componentState).isClaiming,
              disabled: !_unref(userCanClaimRefund),
              onClick: claimRefund
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
              ]),
              _: 1
            }, 8, ["is-loading", "disabled"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})